import * as React from "react";
import {createBrowserRouter, Navigate,} from "react-router-dom";
import AuthLayout from "../class/components/layout/AuthLayout";
import Layout from "../class/components/layout/Layout";
import {PrivateRoute, RoleRestrict} from "../config/Security";
import Register from "../class/pages/auth/Register";
import UsersPage from "../class/pages/manage/users/UsersPage";
import MakeUserPage from "../class/pages/manage/users/MakeUserPage";
import FileManagerPage from "../class/pages/fileManager/FileManagerPage";
import AccountDetailsPage from "../class/pages/account/AccountDetailsPage";
import WalletsPage from "../class/pages/manage/wallets/WalletsPage";
import WalletHistoryPage from "../class/pages/manage/wallets/WalletHistoryPage";
import WalletPage from "../class/pages/wallet/WalletPage";
import LoginWithToken from "../class/pages/auth-new/LoginWithToken";
import SubmitUserInfo from "../class/pages/auth-new/SubmitUserInfo";
import LoginWithEmail from "../class/pages/auth-new/LoginWithEmail";
import ChangeSettingsPage from "../class/pages/manage/setting/ChangeSettingsPage";
import BannersPage from "../class/pages/manage/setting/banners/BannersPage";
import ErrorPage from "../class/pages/errors/ErrorPage";
import Dashboards from "../class/pages/dashboard/Dashboards";
import StockPricePage from "../class/pages/manage/stocks/price/StockPricePage";
import MakePagePage from "../class/pages/manage/pages/MakePagePage";
import PagesPage from "../class/pages/manage/pages/PagesPage";
import BSRequestsPage from "../class/pages/stocks/bs_requests/BSRequestsPage";
import MakeBSRequestPage from "../class/pages/stocks/bs_requests/MakeBSRequestPage";
import StocksPage from "../class/pages/manage/stocks/stocks/StocksPage";
import ProfitsPage from "../class/pages/manage/stocks/profits/ProfitsPage";
import ResetPassword from "../class/pages/auth-new/ResetPassword";
import InstallmentsPage from "../class/pages/stocks/installments/InstallmentsPage";
import MakeInstallment from "../class/pages/stocks/installments/MakeInstallment";
import CheckStock from "../class/pages/check/CheckStock";
import TicketsPage from "../class/pages/tickets/TicketsPage";



export const router = createBrowserRouter([
    {
        path: "/",
        element: <PrivateRoute element={<Layout panel />} panel/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                path: "",
                element: <Dashboards/>
            },
            {
                path: "manage",
                element: <RoleRestrict role="admin"/>,
                children: [
                    {
                        path: "stocks",
                        children: [
                            {
                                path: "price",
                                element: <StockPricePage/>
                            },
                            {
                                path: "view-all",
                                element: <StocksPage manage/>
                            },
                        ],
                    },
                    {
                        path: "profits",
                        children: [
                            {
                                path: "view-all",
                                element: <ProfitsPage manage/>
                            },
                        ],
                    },
                    {
                        path: "support",
                        element: <TicketsPage role={'admin'}/>
                    },
                    {
                        path: "users",
                        children: [
                            {
                                path: "view-all",
                                element: <UsersPage/>
                            },
                            {
                                path: "add",
                                element: <MakeUserPage />
                            },
                            {
                                path: "edit/:id",
                                element: <MakeUserPage edit/>
                            }
                        ],

                    },
                    {
                        path: "setting",  // Base path
                        children: [
                            {
                                path: "view-all",
                                element: <ChangeSettingsPage/>
                            },  {
                                path: "banners",
                                element: <BannersPage/>
                            },
                        ],
                    },
                    {
                        path: "wallets",
                        children: [
                            {
                                path: "view-all",
                                element: <WalletsPage/>
                            }, {
                                path: "transactions/:id",
                                element: <WalletHistoryPage/>
                            },
                        ],

                    },
                    {
                        path: "pages",
                        children: [
                            {
                                path: "view-all",
                                element: <PagesPage/>
                            },
                            {
                                path: "add",
                                element: <MakePagePage />
                            },
                            {
                                path: "edit/:id",
                                element: <MakePagePage edit/>
                            }
                        ],
                    },
                ],

            },
            {
                path: "file-manager",
                element: <FileManagerPage />
            },
            {
                path: "bs-requests",
                children: [
                    {
                        path: "view-all",
                        element: <BSRequestsPage/>
                    },
                    {
                        path: "add",
                        element: <MakeBSRequestPage />
                    },
                    {
                        path: "view/:id",
                        element: <MakeBSRequestPage edit/>
                    }
                ],
            },
            {
                path: "installments",
                children: [
                    {
                        path: "view-all",
                        element: <InstallmentsPage/>
                    },
                    {
                        path: "view/:id",
                        element: <MakeInstallment edit/>
                    }
                ],
            },
            {
                path: "stocks",
                children: [
                    {
                        path: "view-all",
                        element: <StocksPage/>
                    },
                ],
            },
            {
                path: "profits",
                children: [
                    {
                        path: "view-all",
                        element: <ProfitsPage/>
                    },
                ],
            },
            {
                path: "user",
                children: [
                    {
                        path: "account",
                        element: <AccountDetailsPage />
                    },
                    {
                        path: "support",
                        element: <TicketsPage role={'user'}/>
                    },
                    {
                        path: "wallet",
                        element: <WalletPage />
                    },
                ],

            },


        ],

    },
    {
        path: "/login",
        element: <AuthLayout ><LoginWithToken/></AuthLayout>,
    },
    {
        path: "/check",
        element: <CheckStock/>,
    },
    {
        path: "/email-login",
        element: <AuthLayout ><LoginWithEmail/></AuthLayout>,
    },
    {
        path: "/user-info",
        element: <SubmitUserInfo/>,
    },
    {
        path: "/register",
        element: <AuthLayout ><Register/></AuthLayout>,
    },
    {
        path: "/reset-password",
        element: <AuthLayout ><ResetPassword/></AuthLayout>,
    },

]);